<template>
  <div>
    <div v-if='this.$store.state.results.user.result !== false'>
    <h2 class="text-center text-space">{{ computeCaption(fields_en['result'], $store.state.lang.value.toLowerCase())}}</h2>
    <p class="result"  v-html="this.$store.state.results.user.result.result"> </p>
    </div>
    <div v-else>
      <div class="col-md-10 col-md-offset-1">
        <div class="form-group">
          <h5 class="text-center">We couldn't find your registration.</h5>
          <h4 class="text-center">Try again!</h4>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {TranslationsUtils} from '../../../../../utils/Translations'
export default {
  props: {
    result: String
  },
  mixins: [TranslationsUtils],
  data () {
    return {
      fields_en: {
        result: 'Result'
      }
    }
  },
  methods: {
  }
}
</script>

<style scoped>
.result{
  text-align: center;
  font-size: 20px;
}

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Results/Wizard/ResultQR.vue